import { mdiCheck } from '@mdi/js'

import { useAppDispatch } from 'app/hooks'
import { requestAccessThunk } from 'features/home/slice'

import {
  HomeStatusMonitoringAccess,
  StyledLabel,
  StyledTitle,
  HomeStatusSuccessBox,
  HomeStatusSuccessBoxIcon,
} from '../styles'

import RequestAccessButton from './RequestAccessButton'
import theme from 'theme_'
import { useIntl } from 'react-intl'
import { mainInfoMonitoringAccess } from '../messages'

interface HomeMonitoringAccessProps {
  monitorAccessEnabled: boolean
  domainId: string
  id: string
  name: string
}

function HomeMonitoringAccess(props: HomeMonitoringAccessProps) {
  const { domainId, id, monitorAccessEnabled, name } = props
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()

  const requestAccessHandler = () => {
    return dispatch(requestAccessThunk(domainId, id, { monitorAccess: true }))
  }

  return (
    <HomeStatusMonitoringAccess>
      <StyledLabel>
        {formatMessage(mainInfoMonitoringAccess.monitoringAccess)}
      </StyledLabel>
      <StyledTitle>
        {monitorAccessEnabled ? (
          <HomeStatusSuccessBox>
            <HomeStatusSuccessBoxIcon
              path={mdiCheck}
              size={0.8}
              color={theme.colors.successGreen}
            />
            {formatMessage(mainInfoMonitoringAccess.accessGranted)}
          </HomeStatusSuccessBox>
        ) : (
          <RequestAccessButton
            homeName={name}
            requestAccessHandler={requestAccessHandler}
          />
        )}
      </StyledTitle>
    </HomeStatusMonitoringAccess>
  )
}

export default HomeMonitoringAccess
